import useAuthFromUrl from "@/redux/hooks/useAuthFromUrl";
import useSmartlook from "@/redux/hooks/useSmartlook";
import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const location = useLocation();
  const token = localStorage.getItem("auth_token");
  useAuthFromUrl();

  if (!token) {
    // Redirect to SignIn page if user is not authenticated
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  // Use Smartlook only if the user is authenticated
  useSmartlook();

  return <>{children}</>;
};

export default ProtectedRoute;
